import { render, staticRenderFns } from "./LikertScale.vue?vue&type=template&id=d5eaf972&"
import script from "./LikertScale.vue?vue&type=script&lang=js&"
export * from "./LikertScale.vue?vue&type=script&lang=js&"
import style0 from "./LikertScale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports